import {defineComponent, onMounted} from 'vue';

export default defineComponent({
  components: {},
  props: ['modelValue', 'blurFunction'],
  setup: function () {
    onMounted(() => {
    });

    return {};
  },
});
